import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {AuthUserService} from '../services/auth-user.service';

@Injectable({
  providedIn: 'root'
})
export class MainGuard implements CanActivate {
  constructor(
      private authService:AuthUserService,
      ) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      this.authService.navigateToDefaultOnRole();
      return false;
    } else {
      return true;
    }
  }
}
